"use strict";

import angular from "angular";

import template from "./showtime-navigation.component.html";
import "./showtime-navigation.component.scss";

const name = "nuShowtimeNavigation";
const def = {
    bindings: {
        afterNavigate: "=",
        onNavigate: "=",
        isNavigationDisabled: "="
    },
    controllerAs: "showtimeNavigationCtrl",
    template,
    transclude: true
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
